import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, formatMessage } from 'translate';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import TwoKeyStorage from '../../_core/2KeyStorage';
import { UserActions, UtilActions, userSelectors } from '../../_redux';
import { TwoKeyButton } from '.';
import UserVerifyIcon from '../../icons/user_verify.svg';
import './confirmEmail.scss';

const mapStateToProps = state => ({
  isLogoutDialogueOpen: state.general.get('isLogoutDialogueOpen'),
  resendingVerificationEmail: state.user.get('resendingVerificationEmail'),
  isEmailVerificationRequired: userSelectors.isEmailVerificationRequired(state),
});

const mapDispatchToProps = {
  RESEND_VERIFICATION_EMAIL: UserActions.RESEND_VERIFICATION_EMAIL,
  OPEN_LOGOUT_DIALOGUE: UtilActions.OPEN_LOGOUT_DIALOGUE,
};

class ConfirmEmail extends React.Component {
  handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
    TwoKeyStorage.setItem('route', window.location.href.replace(window.location.origin, ''));
    this.props.RESEND_VERIFICATION_EMAIL();
  }

  handleLogoutClick = e => {
    e.stopPropagation();
    e.preventDefault();
    TwoKeyStorage.setItem('route', window.location.href.replace(window.location.origin, ''));
    this.props.OPEN_LOGOUT_DIALOGUE();
  }
  render() {
    const {
      isEmailVerificationRequired, resendingVerificationEmail, isLogoutDialogueOpen,
    } = this.props;
    return (
      <Modal
        className="twokey-modal confirm-email"
        isOpen={!isLogoutDialogueOpen && isEmailVerificationRequired}
        // onRequestClose={this.onClose}
        closeTimeoutMS={100}
        shouldCloseOnOverlayClick={false}
        // overlayClassName="flex"
      >
        <header>
          <h3>
            <FormattedMessage id="main_email_verify.verify_your_email" />
          </h3>
        </header>
        <main>
          <div className="img-wrapper">
            <img src={UserVerifyIcon} alt="" />
          </div>
          <p>
            <FormattedMessage id="main_email_verify.text" />
          </p>
        </main>
        <footer>
          <div>
            <TwoKeyButton
              text={formatMessage({ id: 'main_email_verify.resend_email' })}
              loading={resendingVerificationEmail}
              onClick={this.handleClick}
              processingText={formatMessage({ id: 'main.sending' })}
            />
          </div>
          <div>
            <a onClick={this.handleLogoutClick} className="logout-btn">
              <FormattedMessage id="main.logout" />
            </a>
          </div>
        </footer>
      </Modal>
    );
  }
}

ConfirmEmail.propTypes = {
  isEmailVerificationRequired: PropTypes.bool,
  isLogoutDialogueOpen: PropTypes.bool,
  resendingVerificationEmail: PropTypes.bool,
  RESEND_VERIFICATION_EMAIL: PropTypes.func.isRequired,
  OPEN_LOGOUT_DIALOGUE: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);
